import { render, staticRenderFns } from "./DistrictsView.vue?vue&type=template&id=087ac6ca"
import script from "./DistrictsView.vue?vue&type=script&lang=js"
export * from "./DistrictsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports